import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './tickers.css'

const Tickers = (props) => {
  return (
    <div className="tickers-container10">
      <Helmet>
        <title>Tickers Generative Design Project | Vlad Butucariu</title>
        <meta
          name="description"
          content="Tickers is a generative design experiment comprising 1,900 vector compositions inspired by timekeeping, mechanical systems, and early games."
        />
        <meta
          property="og:title"
          content="Tickers Generative Design Project | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="A self-initiated exploration of generative systems, vector composition, and digital ownership."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/tickers" />
        <meta property="og:url" content="https://vladbutucariu.com/tickers" />
      </Helmet>
      <div className="tickers-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <div className="tickers-thq-top-section-elm">
          <div className="tickers-thq-video-div-elm">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="tickers-video"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="tickers-thq-video-mobile-elm"
            ></video>
          </div>
          <div className="tickers-thq-section-elm1">
            <div className="tickers-thq-color-wrapper-elm1 project-page-shell">
              <div className="tickers-container11 project-page-intro">
                <div className="tickers-container12">
                  <div className="tickers-container13">
                    <img
                      alt="image"
                      src="/Images/tickerpurple.200.svg"
                      className="tickers-image10"
                    />
                    <div className="tickers-thq-title-elm">
                      <h1 className="tickers-text10 header-project">
                        Tickers – Generative NFTs
                      </h1>
                    </div>
                    <div className="tickers-thq-subtitle-elm">
                      <div className="tickers-thq-description-elm1">
                        <h2 className="tickers-thq-heading-elm">
                          Tickers is a collection of 1900 generative vector art
                          NFTs featuring intricate geometric compositions that
                          draw inspiration from time measurement devices,
                          mechanical gears and retro video games.
                        </h2>
                      </div>
                      <div className="tickers-thq-tags-elm">
                        <label className="tag-label-big tickers-text11">
                          digital assets
                        </label>
                        <label className="tickers-text12 tag-label-big">
                          research
                        </label>
                        <label className="tag-label-big tickers-text13">
                          concept
                        </label>
                        <a
                          href="https://foton.is"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="tickers-link10"
                        >
                          <label className="tickers-text14 tag-label-big">
                            https://foton.is
                          </label>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tickers-thq-description-elm2">
                  <div className="tickers-container14">
                    <span className="tickers-text15">context</span>
                    <span className="tickers-text16">
                      While working on the FOTON Digital Assets platform, both
                      application and product strategy and vision, I had to get
                      into the shoes of Creators and experience first hand their
                      challenges as well as their flow in creating NFTs on the
                      platform and outside of it before even joining. This user
                      journey led to the creation of a couple of personal NFT
                      collection, among which is the present one called Tickers.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                  <div className="tickers-container15">
                    <span className="tickers-text17">Design</span>
                    <span className="tickers-text18">
                      <span>
                        Compared to fungible Tokens, NFTs (Non Fungible Tokens)
                        come with more challenges due to their more complex
                        nature of holding an extra package attached to their On
                        Ledger Information. This package in most cases it is an
                        Image, but could range to any type of files. In the
                        research phase for Foton I went over several challenges
                        as file sizes, quality, speed of delivery, etc. SVGs
                        posed an interesting case because while they were
                        offering very reduced sizes for the file compared with
                        JPG or PNGs, could be scaled to any size without losing
                        their quality and remaining very sharp but also could be
                        animated. This led me to the creation of this particular
                        collection for exploring the capabilities of SVGs and
                        their performance within the Foton application.  
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        The compositions are formed of up to 7 layers of
                        geometric shapes and vary based on the grid size, the
                        openness of the pie charts, dot size and color palette.
                        Due to their simple geometric layout and composition,
                        each canvas could be animated based on the movement of
                        the pie charts.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                    </span>
                  </div>
                  <div className="tickers-container16">
                    <span className="tickers-text23">Results</span>
                    <span className="tickers-text24">
                      While the exercise was a very creative one, from a product
                      design perspective it allowed me to discover first hand
                      the challenges the users of the Foton app might encounter.
                      It improved overall my understanding of the user journey,
                      limitations, flow, content delivery, while enhancing the
                      competitiveness of the final product among competitors.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="tickers-thq-color-wrapper-elm2">
              <div className="tickers-container17">
                <div className="tickers-container18">
                  <img
                    alt="image"
                    src="/Projects/Tickers3/ticker.0952.svg"
                    className="tickers-image11"
                  />
                </div>
                <div className="tickers-container19">
                  <img
                    alt="image"
                    src="/Projects/Tickers3/ticker.2302.svg"
                    className="tickers-image12"
                  />
                </div>
              </div>
              <div className="tickers-container20">
                <div className="tickers-container21">
                  <img
                    alt="image"
                    src="/Images/tickerpurple.200.svg"
                    className="tickers-image13"
                  />
                  <p className="tickers-text25">
                    <span className="tickers-text26">
                      The items are available for reservations and will be
                      minted soon on the
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <a
                      href="https://foton.is"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="tickers-link11"
                    >
                      FOTON Marketplace
                    </a>
                    <span className="tickers-text27">
                      . A maximum of 20 items is allowed per user or wallet
                      account. To make a reservation follow the process below.
                    </span>
                    <br className="tickers-text28"></br>
                    <br className="tickers-text29"></br>
                    <span className="tickers-text30">Reservation process:</span>
                    <br className="tickers-text31"></br>
                    <span className="tickers-text32">
                      1. Each item requires 250 XRD (Radix tokens) in exchange
                      for 1 TKR reservation token which can be used to mint the
                      artwork on the FOTON Marketplace when it goes live. 
                    </span>
                    <br className="tickers-text33"></br>
                    <span className="tickers-text34">
                      2. Send the XRD amount to this IRREVERSIBLE Radix account:
                    </span>
                    <br className="tickers-text35"></br>
                  </p>
                  <div className="tickers-container22">
                    <div className="tickers-container23">
                      <p id="clipboardContent" className="tickers-text36">
                        account_rdx16yhf5uz2lqmf2jsc8jhsyjtfka293sqlp0yvmrzllaxyj9zmsnlje7
                      </p>
                      <div className="tickers-container24"></div>
                    </div>
                    <button
                      id="copyBtn"
                      type="button"
                      className="tickers-button button"
                    >
                      <svg viewBox="0 0 1024 1024" className="tickers-icon1">
                        <path d="M810 896v-598h-468v598h468zM810 214q34 0 60 25t26 59v598q0 34-26 60t-60 26h-468q-34 0-60-26t-26-60v-598q0-34 26-59t60-25h468zM682 42v86h-512v598h-84v-598q0-34 25-60t59-26h512z"></path>
                      </svg>
                      <span className="BodyText">Copy</span>
                    </button>
                    <div className="tickers-container25">
                      <div className="tickers-container26">
                        <React.Fragment>
                          <Script>{`
    const btn = document.getElementById('copyBtn')
    const paragraph = document.getElementById('clipboardContent')

    btn.addEventListener('click', ()=>{
    navigator.clipboard.writeText(paragraph.innerText)})
`}</Script>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                  <div className="tickers-container27">
                    <span className="tickers-text38">Full Address View: </span>
                    <span className="tickers-text39">
                      account_rdx16yhf5uz2lqmf2jsc8jhsyjtfka293sqlp0yvmrzllaxyj9zmsnlje7
                    </span>
                  </div>
                  <div className="tickers-container28">
                    <div className="tickers-container29">
                      <img
                        alt="image"
                        src="/Images/qr-radix-account-irreversible.jpg"
                        className="tickers-image14"
                      />
                    </div>
                    <div className="tickers-container30">
                      <p className="tickers-text40">
                        Or scan the QR code directly with your Radix Wallet to
                        add the IRREVERSIBLE address as the receiving Account.
                      </p>
                    </div>
                  </div>
                  <p className="tickers-text41">
                    3. In up to 24 hrs you will receive back the TKR tokens. It
                    is done manually for now! Example: for 4 Artworks send
                    &gt;&gt;&gt; 4 x 250 XRD =  1000 XRD. You will get 4 TKR
                    tokens back to use for minting on FOTON.
                  </p>
                </div>
                <div className="tickers-container31">
                  <p className="tickers-text42">
                    <span>
                      Disclaimer! - IRREVERSIBLE or its team is not responsible
                      in any way if your transactions go wrong. Do not send XRD
                      directly from exchanges, only private wallets! Make sure
                      the address is written in full and that it is the correct
                      one. Do not use Ethereum Wallets for sending tokens, like
                      Metamask or etc. You should use only the official Radix
                      Wallet which can be downloaded
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <a
                      href="https://www.radixdlt.com/wallet"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="tickers-link12"
                    >
                      here
                    </a>
                    <span>.</span>
                    <br></br>
                    <br></br>
                    <span>
                      The TKR tokens are not divisible and stay as whole numbers
                      to avoid fragmentation. Their only use case is to
                      facilitate the minting process for the artwork. The NFTs
                      will be distributed randomly at the time of minting and
                      might have minor visual adjustments. 
                    </span>
                    <br></br>
                  </p>
                  <div className="tickers-container32">
                    <img
                      alt="image"
                      src="/Projects/tickers.png"
                      className="tickers-image15"
                    />
                    <p className="tickers-text49">
                      TKR token image in the Radix Wallet.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tickers-thq-section-elm2">
          <div className="tickers-thq-label-elm">
            <span className="tickers-text50">Loopers</span>
            <span className="tickers-text51">
              animation, nft, collection, art
            </span>
          </div>
          <div className="tickers-container33">
            <div className="tickers-thq-item-elm10">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="tickers-image16"
              />
            </div>
            <div className="tickers-thq-item-elm11">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="tickers-image17"
              />
            </div>
            <div className="tickers-thq-item-elm12">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="tickers-image18"
              />
            </div>
            <div className="tickers-thq-item-elm13">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="tickers-image19"
              />
            </div>
            <div className="tickers-thq-item-elm14">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="tickers-image20"
              />
            </div>
            <div className="tickers-thq-item-elm15">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="tickers-image21"
              />
            </div>
            <div className="tickers-thq-item-elm16">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="tickers-image22"
              />
            </div>
            <div className="tickers-thq-item-elm17">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="tickers-image23"
              />
            </div>
            <div className="tickers-thq-item-elm18">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="tickers-image24"
              />
            </div>
            <div className="tickers-thq-item-elm19">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="tickers-image25"
              />
            </div>
            <div className="tickers-thq-item-elm20">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="tickers-image26"
              />
            </div>
            <div className="tickers-thq-item-elm21">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="tickers-image27"
              />
            </div>
            <div className="tickers-thq-item-elm22">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="tickers-image28"
              />
            </div>
            <div className="tickers-thq-item-elm23">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="tickers-image29"
              />
            </div>
            <div className="tickers-thq-item-elm24">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="tickers-image30"
              />
            </div>
            <div className="tickers-thq-item-elm25">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="tickers-image31"
              />
            </div>
            <div className="tickers-thq-item-elm26">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="tickers-image32"
              />
            </div>
            <div className="tickers-thq-item-elm27">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="tickers-image33"
              />
            </div>
          </div>
        </div>
        <div className="tickers-thq-section-elm3">
          <div className="tickers-thq-color-wrapper-elm3">
            <div className="tickers-container34">
              <div className="tickers-container35">
                <div
                  id="my_nanogallery2"
                  data-nanogallery2='&#123;"thumbnailHeight":300,"thumbnailWidth":300,"thumbnailLabel":&#123;"display":false&#125;,"thumbnailGutterWidth":12,"thumbnailGutterHeight":12,"thumbnailBorderHorizontal":0,"thumbnailBorderVertical":0,"thumbnailL1GutterWidth":16,"thumbnailL1GutterHeight":16,"thumbnailL1BorderHorizontal":0,"thumbnailL1BorderVertical":0&#125;'
                >
                  <a
                    href="/Projects/Tickers3/ticker.1401.svg"
                    target="_blank"
                    rel="noreferrer noopener"
                    data-ngsrc="/Projects/Tickers3/ticker.1401.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.1401.svg"
                      className="tickers-image34"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.0102.svg"
                    target="_blank"
                    rel="noreferrer noopener"
                    data-ngsrc="/Projects/Tickers3/ticker.0102.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.0102.svg"
                      className="tickers-image35"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.2101.svg"
                    target="_blank"
                    rel="noreferrer noopener"
                    data-ngsrc="/Projects/Tickers3/ticker.2101.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.2101.svg"
                      className="tickers-image36"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.0952.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.0952.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.0952.svg"
                      className="tickers-image37"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.1902.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.1902.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.1902.svg"
                      className="tickers-image38"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.1951.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.1951.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.1951.svg"
                      className="tickers-image39"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.0051.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.0051.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.0051.svg"
                      className="tickers-image40"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.2302.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.2302.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.2302.svg"
                      className="tickers-image41"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.1152.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.1152.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.1152.svg"
                      className="tickers-image42"
                    />
                  </a>
                  <img
                    alt="image"
                    src="/Projects/Tickers3/ticker.1851.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.1851.svg"
                    data-nanogallery2-lightbox=""
                    className="tickers-image43"
                  />
                  <a
                    href="/Projects/Tickers3/ticker.2251.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.2251.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.2251.svg"
                      className="tickers-image44"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.0151.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.0151.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.0151.svg"
                      className="tickers-image45"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.0252.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.0252.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.0252.svg"
                      className="tickers-image46"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.0451.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.0451.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.0451.svg"
                      className="tickers-image47"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers2/ticker.2151.svg"
                    data-ngsrc="/Projects/Tickers2/ticker.2151.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers2/ticker.2151.svg"
                      className="tickers-image48"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.0753.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.0753.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.0753.svg"
                      className="tickers-image49"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.2352.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.2352.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.2352.svg"
                      className="tickers-image50"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.003.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.003.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.003.svg"
                      className="tickers-image51"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.007.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.007.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.007.svg"
                      className="tickers-image52"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.012.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.012.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.012.svg"
                      className="tickers-image53"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.027.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.027.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.027.svg"
                      className="tickers-image54"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.037.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.037.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.037.svg"
                      className="tickers-image55"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.0152.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.0152.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.0152.svg"
                      className="tickers-image56"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers3/ticker.0102.svg"
                    data-ngsrc="/Projects/Tickers3/ticker.0102.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers3/ticker.0102.svg"
                      className="tickers-image57"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.114.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.114.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.114.svg"
                      className="tickers-image58"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.029.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.029.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.029.svg"
                      className="tickers-image59"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.207.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.207.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.207.svg"
                      className="tickers-image60"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.236.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.236.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.236.svg"
                      className="tickers-image61"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.241.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.241.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.241.svg"
                      className="tickers-image62"
                    />
                  </a>
                  <a
                    href="/Projects/Tickers4/ticker.233.svg"
                    data-ngsrc="/Projects/Tickers4/ticker.233.svg"
                    data-nanogallery2-lightbox=""
                  >
                    <img
                      alt="image"
                      src="/Projects/Tickers4/ticker.233.svg"
                      className="tickers-image63"
                    />
                  </a>
                </div>
                <div>
                  <div className="tickers-container37">
                    <React.Fragment>
                      <React.Fragment>
                        <Script
                          type="text/javascript"
                          src="https://cdn.jsdelivr.net/npm/nanogallery2@3/dist/jquery.nanogallery2.min.js"
                          async={true}
                          defer={true}
                        />
                      </React.Fragment>
                    </React.Fragment>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  )
}

export default Tickers
